import imageAsset from './imageAsset'

export const fields = `
    eyebrow,
    header,
    subtitle,
    ${imageAsset.fragment('backgroundImage', true)},
    successMessage {
      title,
      subtitle,
    }
  `

export const fragment = (name = 'newsletterSignUp') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
